// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { Cross } from '../../assets/svg/common';
import useRouter from '../../hooks/useRouter';
import theme from '../../styled-components/dark';
import { MultiviewBlockWrapper, MultiviewButton } from '../../styled-components/shared';
import RoutesRedirectionFactory from '../../utils/routes/RoutesRedirectionFactory';

const Content = styled.div`
  height: 100%;
  position: relative;
  background: ${theme.MultiviewBlockAddMatch.background};
`;

const AddButton = styled(MultiviewButton)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 5em;
  height: 5em;

  && {
    border-radius: 50%;
    background: ${theme.MultiviewBlockAddMatch.buttonBackground};

    :hover {
      background: ${theme.MultiviewBlockAddMatch.buttonBackgroundHover};
    }
  }
`;

const AddIcon = styled(Cross)`
  width: 2.5em;
  height: 2.5em;
  transform: rotate(45deg);
  color: ${theme.MultiviewBlockAddMatch.buttonColor};
`;

const MultiviewBlockAddMatch = () => {
  const { history } = useRouter();

  const handleSetShowMatchList = () => {
    history.push(RoutesRedirectionFactory.getMultiviewEventListRouteConfig());
  };

  return (
    <MultiviewBlockWrapper>
      <Content>
        <AddButton onClick={handleSetShowMatchList}>
          <AddIcon title="addIcon" />
        </AddButton>
      </Content>
    </MultiviewBlockWrapper>
  );
};

export default MultiviewBlockAddMatch;
